import { render } from "./App.vue?vue&type=template&id=4878248a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4878248a&lang=css"

import exportComponent from "/Users/PAB/Dropbox/thinkbeyond/dev/tgs/tb-tgs-watcher/src/main/vueapp/watcher-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__